import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import { Translate, I18n } from "react-redux-i18n";
import { searchModule, prepareCSVDownload } from "../utils/Utils";
import { setAlert } from "../../actions/alertActions";
import AddUsersByPhone from "../utils/components/AddUsersByPhone";
import "../../styles/utils/_loadingScreen.scss";
import "../../styles/components/evs/DriversTable.scss";
import trashcan from "../../styles/images/trashcan.svg";
import no_vehicles from "../../styles/images/no_vehicles.svg";
import { StatusCodes } from "http-status-codes";
import xlsx from "xlsx";
import ChoiceModal from "../utils/components/ChoiceModal";
import $ from "jquery";
import download from "../../styles/images/download.svg";
import toggle from "../utils/evio-toggle";
import DriverAssociatedLicensePlates from "./modals/DriverAssociatedLicensePlates";


class DriversTable extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      loading: true,
      poolId: "",
      drivers: [],
      search: "",
      licensePlates: [],

      modals: {
        add: false,
        choiceDriver: false,
        driverAssociatedLicensePlates: false,
      },
    };

    this.handleAddDrivers = this.handleAddDrivers.bind(this);
    this.handleDeleteDriver = this.handleDeleteDriver.bind(this);
    this.prepareExportCollaborator = this.prepareExportCollaborator.bind(this);
    this.associatedEvs = this.associatedEvs.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchDrivers(() => {
      this.safeSetState({ search: this.props.search });
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.hasOwnProperty("search") &&
      this.props.hasOwnProperty("search")
    )
      if (prevProps.search !== this.props.search)
        this.safeSetState({ search: this.props.search });
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  setModal(modal, bool, callback) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState(
      {
        modals: newModals,
      },
      callback
    );
  }

  fetchDrivers(callback) {
    axios
      .get("/api/private/drivers")
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState(
            {
              loading: false,
              poolId: res.data._id,
              drivers: res.data.poolOfDrivers || [],
            },
            callback
          );
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.code)
          this.props.setAlert(I18n.t(err.response.data.message), "danger");
        else this.props.setAlert(I18n.t("general_error"), "danger");
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  }

  handleAddDrivers(users) {
    const drivers = users.map((u) => ({
      driverId: u._id,
      mobile:
        u.mobile || u.phone.replace(/[^0-9]+/g, "").slice(u.prefix.length),
      internationalPrefix: u.internationalPrefix || "+" + u.prefix,
    }));

    const put = { _id: this.state.poolId, drivers };

    axios
      .put("/api/private/drivers", put, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === StatusCodes.CREATED) {
          this.props.setAlert(I18n.t("drivers_successAdd"), "primary");
          this.fetchDrivers();
          this.setModal("add", false);
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.code)
          this.props.setAlert(I18n.t(err.response.data.message), "danger");
        else this.props.setAlert(I18n.t("general_error"), "danger");
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  }

  handleDeleteDriver(e, driver) {
    const bool = window.confirm(
      "Are you sure you want to delete " + driver.mobile + "?"
    );
    if (bool) {
      const patch = {
        _id: this.state.poolId,
        drivers: [
          {
            driverId: driver.driverId,
            mobile: driver.mobile,
            internationalPrefix: driver.internationalPrefix,
          },
        ],
      };

      axios
        .patch("/api/private/drivers", patch, {
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status === 200) {
            this.props.setAlert(I18n.t("drivers_successDelete"), "primary");
            this.fetchDrivers();
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.code)
            this.props.setAlert(I18n.t(err.response.data.message), "danger");
          else this.props.setAlert(I18n.t("general_error"), "danger");
          if (axios.isCancel(err)) console.log("axios", err);
          else console.log(err);
        });
    }
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  prepareExportCollaborator(listDrivers) {
    let ListOfDriversPrepared = [];

    if (listDrivers.length > 0) {
      listDrivers.forEach((element) => {
        const name = I18n.t("exportAssets_name");
        const mobile = I18n.t("exportAssets_mobile");
        const numberOfEvs = I18n.t("exportAssets_numberOfEvs");
        const associatedLicensePlates = I18n.t(
          "drivers_associatedLicensePlateModalTitle"
        );

        let driver = {
          [name]: element.name,
          [mobile]: element.mobile,
          [numberOfEvs]: element.numberOfEvs,
          [associatedLicensePlates]: element.licensePlates.toString(),
        };
        ListOfDriversPrepared.push(driver);
      });
    }
    return ListOfDriversPrepared;
  }

  handleOnChooseCollaborator(idx) {
    this.setModal("choiceCollaborator", false);

    const dataEv = this.prepareExportCollaborator(this.state.drivers);
    let ws = xlsx.utils.json_to_sheet(dataEv, {
      header: [
        I18n.t("exportAssets_name"),
        I18n.t("exportAssets_mobile"),
        I18n.t("exportAssets_numberOfEvs"),
        I18n.t("drivers_associatedLicensePlateModalTitle"),
      ],
    });
    const sheetName =
      this?.props?.accountData?.name + " - " + I18n.t("drivers_drivers");
    if (idx === 0) {
      let ws_to_csv = xlsx.utils.sheet_to_csv(ws);
      const newDataEV = ws_to_csv.split("\n").map((s) => s.split(","));
      
      const download = prepareCSVDownload(newDataEV, sheetName + ".csv");
      $("#downloadFile").append(download);
      download.click();
      $("#downloadFile").remove(download);
    } else if (idx === 1) {
      let wb = xlsx.utils.book_new();

      wb.SheetNames.push(sheetName);

      wb.Sheets[sheetName] = ws;

      xlsx.writeFile(wb, `${sheetName}.xlsx`);
    }
  }

  associatedEvs(userInfo) {
    const numberOfEvs = userInfo?.numberOfEvs ?? -1;
    const licensePlates = userInfo?.licensePlates ?? [];

    if (numberOfEvs <= 0) {
      return "—";
    }

    const firstPlate = licensePlates[0] ?? "—";

    return numberOfEvs === 1
      ? firstPlate
      : `${firstPlate} + ${numberOfEvs - 1}`;
  }

  render() {
    return !this.state.loading ? (
      <>
        <button
          type="button"
          className="main-btn"
          onClick={() => this.setModal("add", true)}
          disabled={
            this.state.loading ||
            (this.props.isAdmin === false &&
              this.state.drivers.length >= this.props.userPackage?.driversLimit)
          }
        >
          <Translate value="drivers_addDriver" />
        </button>
        <div id="driversTable">
          <div className="component-container">
            {this.state.drivers.length > 0 ? (
              <div className="table-container">
                <div className="table-header">
                  <div className="row no-gutters">
                    <div className="col-12 row no-gutters titles">
                      <div className="col title">
                        <Translate value="drivers_drivers" />
                      </div>
                      <div className="col title">
                        <Translate value="drivers_phoneNumber" />
                      </div>
                      <div className="col title">
                        <Translate value="drivers_evs" />
                      </div>
                      <div className="col-2 title"></div>
                    </div>
                  </div>
                </div>
                <div className="table-values">
                  {this.state.drivers
                    .filter((i) => searchModule.filter(this, i))
                    .map((d, idx) => {
                      const key = d._id || idx;
                      return (
                        <div key={key} className="row no-gutters">
                          <div className="col-12 row no-gutters values">
                            <div className="col">
                              {d.name && d.name !== "" ? (
                                d.name
                              ) : (
                                <Translate
                                  className="muted"
                                  value="groups_notEvioUser"
                                />
                              )}
                            </div>
                            <div className="col">
                              {d.internationalPrefix} {d.mobile}
                            </div>
                            <div className="col pointerMouse">
                              <span
                                onClick={() => {
                                  this.safeSetState({
                                    licensePlates: d.licensePlates,
                                  });
                                  this.setModal(
                                    "driverAssociatedLicensePlates",
                                    true
                                  );
                                }}
                              >
                                {this.associatedEvs(d)}
                              </span>
                            </div>
                            <div className="col-2">
                              <button
                                type="button"
                                className="clear"
                                onClick={(e) => this.handleDeleteDriver(e, d)}
                              >
                                <img src={trashcan} alt="" />
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
                  <div className="absoluteRight">
                    <button
                      type="button"
                      className="export-btn-history"
                      onClick={() => this.setModal("choiceDriver", true)}
                    >
                      <div className="export-bt-text">
                        <Translate value="exportAssets_drivers" />
                      </div>
                      <img alt="evio_img7" src={download} />
                    </button>
                  </div>

                <DriverAssociatedLicensePlates
                  show={this.state.modals.driverAssociatedLicensePlates}
                  onHide={() => {
                    this.setModal("driverAssociatedLicensePlates", false);
                  }}
                  licensePlates={this.state.licensePlates}
                />

                <ChoiceModal
                  show={this.state.modals.choiceDriver}
                  onHide={() => this.setModal("choiceDriver", false)}
                  choices={[
                    { content: "CSV", name: "csv" },
                    { content: "XLSX", name: "xlsx" },
                  ]}
                  chooseBtnLabel="exportAssets_drivers"
                  onChoose={(e) => this.handleOnChooseCollaborator(e)}
                />
              </div>
            ) : (
              <div className="no-groups-container">
                <img src={no_vehicles} alt="" />
                <p className="title">
                  <Translate value="evs_noDriversTitle" />
                </p>
                <p className="text">
                  <Translate value="evs_noDriversText" />
                </p>
              </div>
            )}
          </div>
          <AddUsersByPhone
            show={this.state.modals.add}
            onHide={() => this.setModal("add", false)}
            onSubmit={this.handleAddDrivers}
            title="drivers_addDriver"
          />
        </div>
      </>
    ) : (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="generic-loading">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
  accountData: state.account.accountData,
});

export default connect(mapStateToProps, { setAlert })(DriversTable);